export const newsURLs = {
  namespaced: true,
  state: {
    ICARAbstractsURL: "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216332/Abstracts+and+Programs+from+the+International+Arabidopsis+Meetings",
    howToPostAJobURL: "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216127/FAQ#How-do-I-post-a-job-opening-at-TAIR?"
  },

  getters: {
    getICARAbstractsURL: state => {
      return state.ICARAbstractsURL
    },

    getHowToPostAJobURL: state => {
      return state.howToPostAJobURL
    }
  }
}